export default "__VITE_ASSET__BYyWAQI2__"